<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><br/><br/><br/><br/><br/><br/></p>
<p class="center01"><strong>POUR ELIZABETH « BOOM-BOOM » EULBERG<br/>VIVE LE E.E.C.!</strong><br/><br/><br/><br/></p>
<div class="box1">
<p class="center00"><strong>Avis aux parents et enseignants</strong></p>
<p class="center00">Les fôtes d’ortograf<br/>dent les BD de Georges et Harold<br/>son vous lues.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?091c699f